import { render, staticRenderFns } from "./PropertyContent.html?vue&type=template&id=00c093fc&"
import script from "./PropertyContent.ts?vue&type=script&lang=ts&"
export * from "./PropertyContent.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_content.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports